export default () => ({
  topic: null,
})
